// extracted by mini-css-extract-plugin
export default {"copyDiv":"copy-link-result-modal__copy-div__NVY6M"};